class Breakpoint {
    value: String;

    constructor() {
        this.setValue();

        window.addEventListener('resize', () => {
            this.setValue();
        }, true);
    }

    setValue() {
        this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/"/g, '');
    }
}

export default Breakpoint;